// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
import { Env } from './environment.model';

/**
 * Preprod environment
 */
export const environment: Env = {
    key: '66ef0dd9-007c-4eca-94fb-dbb808497f3f',
    production: false,
    envName: 'preprod',
    cacheDuration: 3600,
    availableLanguages: ['ar', 'de', 'en', 'en-IN', 'es', 'fr', 'hi', 'it', 'ru', 'vi', 'zh-CN', 'zh-TW'],
    responsibilitiesIds: [
        'c621894d-1008-454d-b2bb-ad7d791da134',
        '8cd4ba7f-9463-4547-87d0-b05277a9bf23',
        'cbabb241-a56c-4508-9658-f3114bdb86bb',
        '400dc46c-c711-4285-880c-6078b2b8f5b9',
        '8684205a-f3d1-4ce4-b381-c229e17c0882',
    ],
    exchangeAdminUrl: 'https://exchange-admin.gw2.preprod-01.hr-self-improv-staging-2jqu.decathlon.io/',
    openSatisfactionPopup: true,
    authorizationRedirectUrl: 'https://exchange-client.gw2.preprod-01.hr-self-improv-staging-2jqu.decathlon.io/',
    oauthConfig: {
        production: true,
        stsAuthority: 'https://preprod.idpdecathlon.oxylane.com',
        clientId: 'C8eeeff8d92cce3ec8414ebf2f977780c9a5627c0',
        clientRoot: window.location.origin,
        clientScope: 'openid profile',
    },
    exchangeApi: {
        url: 'https://api-global.preprod.decathlon.net/nexchange_api/api/',
    },
    s3Client: 'https://storage.googleapis.com/exchange-v2-preprod/',
    mediaUrl: 'https://storage.googleapis.com/exchange-v2-preprod/media/',
    catalogExchangeUuid: 'cf1185d3-5010-4f32-8635-1e0f92068075',
    catalogClientId: 'Ccb38fd43783c92e37dfb0c4858ae1b9d6fd4abb4',
    gaMeasurementId: 'UA-117670695-3',
    phrase: {
        url: 'https://api.phrase.com/v2/projects/8fc2dc7541638cb97edbb42246d1f329/',
        token: 'token ' + '68f26bdfcedacb3e2662996fcc3c393c5997ece72c6c699fe78b2e47ebad53b3',
    },
    maintenanceMode: false,
    maintenanceEmails: [],
    bealink: 'https://app.bealink.io/?company=decathlonpp',
    datadog: {
        applicationId: 'a7cef634-7c74-4f2c-9425-9d7354ba98a9',
        clientToken: 'pub12a5189a65c488d704cc43da0b2799fc',
        site: 'datadoghq.eu',
        env: 'staging',
        version: 'process.env.APP_VERSION',
        sessionSampleRate: 100,
        sessionReplaySampleRate: 0,
    },
};
